import { RequirePermission } from "@/components/RequirePermission";
import { PeriodTable } from "@/components/controller/PeriodTable";

const Periods = () => (
  <RequirePermission anyOf={["view_financials"]}>
    <div className="space-y-4">
      <h1 className="text-2xl font-bold tracking-tight">Accounting Periods</h1>
      <PeriodTable />
    </div>
  </RequirePermission>
);

export default Periods;
